import { useState } from 'react';
import classnames from 'classnames/bind';

import { useTimeout } from '@autopass-web/domain';

import { MochiLottie } from '../../mochi-lib/mochi-lottie';
import autopassTextAnimate from './autopass-splash.json';
import autopassTextStatic from './autopass-stop.json';
import styles from './index.module.scss';
import loadingBar from './loading-bar.json';
const cx = classnames.bind(styles);

export const SPLASH_DURATION = 900;

interface SplashProps {
  init: boolean;
}

const Splash = ({ init }: SplashProps) => {
  const [hide, setHide] = useState(false);
  const [isBackgroundAnimationStart, setIsBackgroundAnimationState] =
    useState(false);

  const splashClass = cx({
    splash: true,
    init: isBackgroundAnimationStart,
    hide,
  });

  useTimeout(
    () => {
      setIsBackgroundAnimationState(true);
      setTimeout(() => {
        setHide(true);
      }, SPLASH_DURATION);
    },
    init ? 700 : null,
  );

  if (hide) return null;

  return (
    <div className={splashClass}>
      <div className={styles.lottie}>
        <div className={styles.text}>
          <MochiLottie
            style={{ width: 220 }}
            loop={false}
            animationData={autopassTextStatic}
          />
        </div>
        <div className={styles.text}>
          <MochiLottie
            style={{ width: 220 }}
            loop={false}
            stopped={!init}
            animationData={autopassTextAnimate}
          />
        </div>

        <div className={styles.bar}>
          <MochiLottie style={{ width: 270 }} animationData={loadingBar} />
        </div>
      </div>
    </div>
  );
};

export default Splash;
